<template>
  <div class="contact">
    <div id="breadcrumb">Dürrenmatt Stoffe /<br /><strong>Kontakt</strong></div>
    <div class="intro">
        <div class="introbandtitel short">
          <h1 class="autor">Friedrich Dürrenmatt</h1>
          <h1 class="projekt">Das Stoffe-Projekt</h1>
          <h3 class="projekt gross">Online-Version</h3>
        </div>
  <p class="intro-autor" >der textgenetischen Edition in fünf Bänden<br />
aus dem Nachlass herausgegeben<br />
von Rudolf Probst und Ulrich Weber</p>
  <p class="intro-autor"><i>Alle Rechte vorbehalten: Diogenes Verlag AG Z&uuml;rich, Copyright 2021</i></p>
      <h1 class="intro-bereich">Kontakt</h1>

      <p>
Schweizerisches Literaturarchiv SLA<br />
Hallwylstrasse 15<br />
3003 Bern<br />
Schweiz<br />
Telefon +41 58 462 92 58<br />
Fax +41 58 462 84 08<br />
E-Mail <a href="mailto:arch.lit@nb.admin.ch">arch.lit@nb.admin.ch</a>


      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Kontakt",
  components: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";
 a {
   color: $color-red;
   text-decoration: underline;
 }
</style>

